// Constants
import { ADMIN_DASHBOARD_URL, AGENT_URL, BELESPRIT_URL, CONSOLE_URL, DOCS_URL, EMAIL_BUILDER_URL, STORE_URL, STUDIO_URL } from 'constants/environment'

// Data: Products
const products = {
	admin: {
		name: 'Admin dashboard',
		tokenType: 'platform',
		url: ADMIN_DASHBOARD_URL
	},
	agent: {
		name: 'Agent',
		tokenType: 'platform',
		url: AGENT_URL
	},
	belesprit: {
		name: 'Bel Esprit',
		tokenType: 'belEsprit',
		url: BELESPRIT_URL
	},
	console: {
		name: 'Console',
		tokenType: 'platform',
		url: CONSOLE_URL
	},
	docs: {
		name: 'Docs',
		tokenType: 'platform',
		url: DOCS_URL
	},
	email: {
		name: 'Email builder',
		tokenType: 'platform',
		url: EMAIL_BUILDER_URL
	},
	/*
	label: {
		name: 'Label studio',
		tokenType: '',
		url: ''
	},
	*/
	store: {
		name: 'Store',
		tokenType: 'platform',
		url: STORE_URL
	},
	studio: {
		name: 'Studio',
		tokenType: 'platform',
		url: STUDIO_URL
	}
}

// Export
export default products
